import React from 'react'
import JustLookingModalBox from '../leave_plan_benefits/shared/JustLookingModalBox'

class ActivateLeavePlanFromSetting extends React.Component {
  constructor () {
    super ()

    this.state = {
      activate_leave_plan_modal: false
    }
  }

  infoTexts () {
    return [
      "Add Voluntary Tasks to your LeavePlan",
      "Set reminders for important tasks",
      "Enable sharing of key LeavePlan details with your Manager and HR (you share when you're ready)"
    ]
  }

  modalButtons () {
    return ({
      cancel: 'Later',
      confirm: 'Activate Now'
    })
  }

  handleClick (e) {
    e.preventDefault()
    this.handleJustLookingClick(true)
  }

  handleJustLookingClick (value) {
    this.setState({
      activate_leave_plan_modal: value
    })
  }

  renderJustLookingModalBox () {
    if (this.state.activate_leave_plan_modal) {
      return <JustLookingModalBox
        handleJustLookingClose={this.handleJustLookingClick.bind(this)}
        infoTexts={this.infoTexts()}
        buttons={this.modalButtons()}
      />
    }
  }

  render () {
    return (
      <div>
        <div className='leave_plan_activation_link'>
          <a href='' onClick={(e) => this.handleClick(e, this)}>Activate your LeavePlan</a>
          {this.props.text}
        </div>
        {this.renderJustLookingModalBox()}
      </div>
    )
  }
}

export default ActivateLeavePlanFromSetting;